module.exports = __webpack_public_path__ + "static/media/bronze_pkg_icon.d88cf81e.svg";